import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import DowntimePage from "../Pages/Downtime/DowntimePage";
import Loader from "../Components/Loader";
import { fetchDowntime } from "../Services/AppAction";

const DowntimeGuard = () => {
  const [isDown, setIsDown] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    const checkDowntime = async () => {
      try {
        const res = await fetchDowntime();
        const status = (res as any)?.data[0].SYS_DOWN;

        if (isMounted) {
          setIsDown(status === "Y");
        }
      } catch (err) {
        console.error("Downtime check failed:", err);
        // Fail-open: don't lock everyone out just because this one
        // check errored (network blip, etc).
        if (isMounted) {
          setIsDown((prev) => (prev === null ? false : prev));
        }
      }
    };

    checkDowntime();

    return () => {
      isMounted = false;
    };
    // Re-check on every route change ("redirect to somewhere") instead
    // of a blind timer. This also covers the very first load, since
    // `location` already has a value on initial mount.
  }, [location.pathname]);

  // Only the very first check (isDown still null) shows the full-screen
  // loader. Later route-change re-checks update isDown directly without
  // passing back through null, so navigating around the app doesn't
  // flash the loader every time.
  if (isDown === null) {
    return <Loader loading />;
  }

  return isDown ? <DowntimePage /> : <Outlet />;
};

export default DowntimeGuard;
